/* eslint-disable no-self-assign */
import emailTemplate from '@/api/emailTemplate'
import get from 'lodash/get'

const INITIAL_STATE = {
  emailTemplateList: {},
  emailTemplateLabels: [],
}

export default {
  namespace: 'emailTemplate',

  state: INITIAL_STATE,

  reducers: {
    init() {
      return { ...INITIAL_STATE }
    },
    setEmailTemplateList(state, { payload }) {
      return { ...state, emailTemplateList: payload }
    },
    setEmailTemplateLabels(state, { payload }) {
      return { ...state, emailTemplateLabels: payload }
    },
  },

  effects: {
    *createEmailTemplate({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(emailTemplate.createEmailTemplate, {
        data: {
          ...payload,
          createdBy: get(account, 'accountId'),
          accountId: get(account, 'accountId'),
        },
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }

      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },

    *editEmailTemplate({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(emailTemplate.editEmailTemplate, {
        data: {
          ...payload,
          accountId: get(account, 'accountId'),
        },
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },

    *getEmailTemplates({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(emailTemplate.getEmailTemplates, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        yield put({ type: 'emailTemplate/setEmailTemplateList', payload: resData })
        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getEmailTemplateHtml({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(emailTemplate.getEmailTemplateHtml, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let error = true

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined

          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.()
      }
    },

    *getEmailTemplateHisHtml({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(emailTemplate.getEmailTemplateHisHtml, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let error = true

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined

          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.()
      }
    },

    *getEmailTemplateLabels({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(emailTemplate.getEmailTemplateLabels, {
        params: { accountId: get(account, 'accountId'), ...payload },
      })
      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        yield put({ type: 'emailTemplate/setEmailTemplateLabels', payload: resData })

        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getEmailTemplateAddableLabels({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const { emailTempId, ...restPayload } = payload
      const response = yield call(emailTemplate.getEmailTemplateAddableLabels, {
        emailTempId,
        params: { accountId: get(account, 'accountId'), ...restPayload },
      })
      const { status, data: resData } = response

      let hasError = true

      if (status === 200) {
        hasError = false

        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getEmailTemplateLabelsById({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(emailTemplate.getEmailTemplateLabelsById, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let error = true

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined

          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.()
      }
    },

    *getEmailTemplateById({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(emailTemplate.getEmailTemplateById, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let error = true

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined

          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.()
      }
    },

    *getEmailTemplateHisById({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(emailTemplate.getEmailTemplateHisById, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let error = true

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined

          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.()
      }
    },

    *deleteEmailTemplate({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(emailTemplate.deleteEmailTemplate, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *deleteEmailTemplateLabel({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(emailTemplate.deleteEmailTemplateLabel, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *uploadEmailTemplateImage({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(emailTemplate.uploadEmailTemplateImage, {
        data: payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined
          successCallback?.(data)
        } else {
          error = message
          errorCallback?.(error)
        }
      }
    },
  },
}
